import src from "IMAGE";
export default { src, width: 800, height: 145, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/ADw8PDgzMzMvNDQ0Lz8/Pzo5OTkzQUFBOzExMS0wMDArcpAGzpJl/YIAAAAASUVORK5CYII="};
